<template>
    <div class="banner">
        <p class="header">
            Try Coroot now!
        </p>
        <p class="message">
            It really takes only a few minutes without the need for any configuration or integration
        </p>
        <div class="d-sm-flex">
            <router-link :to="{name: 'signup'}" class="filled-blue d-block d-sm-inline text-center mr-0 mr-sm-5">Start free trial</router-link>
            <a href="https://community-demo.coroot.com/" target="_blank" class="filled-green d-block d-sm-inline text-center mt-5 mt-sm-0">Live demo</a>
        </div>
    </div>
</template>

<script>
export default {
}
</script>

<style scoped>

.banner {
    padding: 80px 60px;
}
.header {
    font-size: 24px;
    font-weight: 600;
    line-height: 1.5;
}
.message {
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    margin-bottom: 36px;
}
@media (min-width: 600px) {
    .banner .header {
        font-size: 28px;
    }
    .banner .message {
        font-size: 18px;
    }
}
@media (min-width: 960px) {
    .banner .header {
        font-size: 36px;
    }
    .banner .message {
        font-size: 20px;
    }
}
</style>
